/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Device,
    DeviceFromJSON,
    DeviceFromJSONTyped,
    DeviceToJSON,
} from './';

/**
 * 
 * @export
 * @interface DeviceDataFrame
 */
export interface DeviceDataFrame {
    /**
     * 
     * @type {number}
     * @memberof DeviceDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Device>}
     * @memberof DeviceDataFrame
     */
    data: Array<Device>;
}

export function DeviceDataFrameFromJSON(json: any): DeviceDataFrame {
    return DeviceDataFrameFromJSONTyped(json, false);
}

export function DeviceDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(DeviceFromJSON)),
    };
}

export function DeviceDataFrameToJSON(value?: DeviceDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(DeviceToJSON)),
    };
}


